// $(document).ready(function () {
// 	CKEDITOR.inline();
// });